"use client";

import React, { useState } from "react";

interface FaqToggleWrapperProps {
  children: React.ReactNode;
}

const FaqToggleWrapper: React.FC<FaqToggleWrapperProps> = ({ children }) => {
  const [showAllFaqs, setShowAllFaqs] = useState(false);

  return (
    <>
      <div style={{ display: showAllFaqs ? "block" : "none" }}>{children}</div>

      {!showAllFaqs ? (
        <div className="flex justify-center">
          <button
            type="button"
            onClick={() => setShowAllFaqs(true)}
            className="block mx-auto bg-[#2A85FF] tracking-normal rounded-[12px_12px_12px_0px] text-white font-bold py-1 px-4 md:h-[36px] text-sm text-center md:w-[150px] md:mt-2 mt-0"
          >
            Read More
          </button>
        </div>
      ) : (
        <div className="flex justify-center mt-6">
          <button
            type="button"
            onClick={() => setShowAllFaqs(false)}
            className="block mx-auto bg-[#2A85FF] tracking-normal rounded-[12px_12px_12px_0px] text-white font-bold py-1 px-4 md:h-[36px] text-sm text-center md:w-[150px] md:mt-2 mt-0"
          >
            Read Less
          </button>
        </div>
      )}
    </>
  );
};

export default FaqToggleWrapper;
